<template>
  <div>
    <label
      :for="`perf-chart-symbol-input-${id}`"
      class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
      v-if="shouldShowLabel"
    >COMPARISON SYMBOLS</label>
    <br v-if="shouldShowLabel" />
    <input
      type="text"
      placeholder=""
      class="sc3-text-input sc3-text-input-inline sc3-text-input-compact sc3-text-input-grey-and-black sc3-text-input-no-margins"
      :id="`perf-chart-symbol-input-${id}`"
      v-model="perfChartSymbol"
      @change="handlePerfChartSymbolChanged($event)"
      ref="perfChartSymbolInputElement"
      @keydown.enter="handleEnterKeyDownPerfChartSymbolInput()"
      @blur="handleBlurPerfChartSymbolInput()"
      autocomplete="off"
    />
  </div>
</template>

<script lang="ts" setup>
  import { ref, toRefs, watch } from 'vue';
  import { useAuthentication } from '@/composables/useAuthentication';
  import { usePerfChartSymbols } from '@/composables/usePerfChartSymbols';
  import { useModals } from '@/composables/useModals';
  import { PerfChartSymbol } from '@/interfaces/chart';

  const { isLoggedIn } = useAuthentication();
  const { MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS_FOR_FREE_USERS } = usePerfChartSymbols();
  const { launchCreateAccountModal } = useModals();
  const props = defineProps<{
    id: string;
    shouldShowLabel: boolean;
    perfChartSymbol: string;
    perfChartSymbols: PerfChartSymbol[];
  }>();
  const {
    id,
    shouldShowLabel,
    perfChartSymbol: parentPerfChartSymbol,
    perfChartSymbols
  } = toRefs(props);

  const emit = defineEmits<{
    (e: 'update:perfChartSymbol', perfChartSymbol: string): void;
    (e: 'perfChartSymbolInputChanged'): void;
  }>();

  const perfChartSymbol = ref(parentPerfChartSymbol.value);
  const perfChartSymbolInputElement = ref<HTMLInputElement>();

  function handlePerfChartSymbolChanged(e: Event) {
    if (!(e.target instanceof HTMLInputElement)) {
      return;
    }

    const currentNumberOfNonEmptyStringPerfChartSymbols = perfChartSymbols.value.filter(perfChartSymbolObject => perfChartSymbolObject.symbol.trim());

    if (
      !isLoggedIn.value &&
      currentNumberOfNonEmptyStringPerfChartSymbols.length >= MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS_FOR_FREE_USERS &&
      !parentPerfChartSymbol.value.trim()
    ) {
      syncPerfChartSymbol();
      launchCreateAccountModal();
      return;
    }

    emit('update:perfChartSymbol', e.target.value);
  }

  function handleEnterKeyDownPerfChartSymbolInput() {
    perfChartSymbolInputElement.value?.blur();
  }

  function handleBlurPerfChartSymbolInput() {
    emit('perfChartSymbolInputChanged');
  }

  function syncPerfChartSymbol() {
    perfChartSymbol.value = parentPerfChartSymbol.value;
  }

  watch(parentPerfChartSymbol, syncPerfChartSymbol);
</script>
